module.exports = __webpack_public_path__ + "media/images/mobile-settings-background-c9ed59e6.png";